<template>
    <MiscLink
        v-for="(menuItem, index) in visibleMenuItems"
        :key="'staticMenu' + (index + 1)"
        :to="menuItem.url"
        :target="menuItem.newTab ? '_blank' : null"
        :class="linkClass"
    >
        {{ menuItem.title }}
    </MiscLink>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
    data: Record<string, any>
    linkClass: string
}>()

const visibleMenuItems = computed(() => {
    return Array.from({ length: 7 }, (_, i) => {
        const index = i + 1
        return {
            title: props.data?.[`staticMenu${index}Title`]?.value,
            url: props.data?.[`staticMenu${index}Url`]?.value,
            newTab: props.data?.[`staticMenu${index}NewTab`]?.value,
        }
    }).filter(item => !!item.title)
})
</script>
